import { useState } from "react";

export const useInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);

    return {
        value,
        setValue,
        reset: ({ initialValue }) => setValue(initialValue),
        bind: {
            value,
            onChange: (event) => {
                setValue(
                    event.target.type && event.target.type === "checkbox" ? event.target.checked : event.target.value
                );
            },
        },
    };
};
